module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av99-d9e9e0ebb26d18929c209db817e15d91.jpg";